<script setup lang="ts">
interface Props {
  label?: string | null
  labelClass?: VueClassProp
  labelErrorIndicator?: 'none' | 'color' | 'asterisk' | 'color-asterisk'
  error?: boolean
  errorClass?: VueClassProp
  justify?: 'between' | 'center' | 'left' | 'right'
  errorMessage?: string | null
  hint?: string | null
  hintClass?: VueClassProp
  noHint?: boolean
  borderless?: boolean
  disabled?: boolean
  readonly?: boolean
  grow?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  errorClass: 'p-invalid',
  labelErrorIndicator: 'color',
  justify: 'between',
  errorMessage: null,
  hint: null,
  hintClass: undefined,
  label: null,
  labelClass: undefined,
  readonly: false,
})

const error = toRef(() => props.error)

const labelClass = computed(() => {
  const classList: VueClassProp[] = []
  if (props.labelClass) {
    classList.push(props.labelClass)
  }
  if (error.value && props.errorClass && props.labelErrorIndicator.includes('color')) {
    classList.push(props.errorClass)
  }
  return classList
})

const conatinerClass = computed(() => {
  const classList: VueClassProp[] = [
    'text-[0.875rem] md:text-[1rem]',
    'flex flex-col self-stretch',
    {
      'h-[39px] md:h-[46px]': !props.grow,
      'min-h-[39px] md:min-h-[46px]': props.grow,
    },
    'gap-3',
    'w-full',
    'px-[10px] py-[8px] md:px-[12px] md:py-[10px]',
    'gap-4',
    `justify-${props.justify}`,
  ]

  if (props.disabled) classList.push('bg-[var(--p-form-field-disabled-background)]')

  if (!props.borderless) classList.push('border rounded-lg')

  if (error.value && props.errorClass && props.labelErrorIndicator.includes('color'))
    classList.push(props.errorClass)
  else classList.push('border-[var(--p-form-field-border-color)]')

  return classList
})

provide('error', error)
</script>

<template>
  <div class="flex flex-col justify-between">
    <div :class="conatinerClass">
      <label
        v-if="label"
        :class="labelClass"
      >
        <span class="font-bold min-h-3 h-md:min-h-6">{{ label }}</span>
        <span
          v-if="error && labelErrorIndicator.includes('asterisk')"
          :class="errorClass"
        >
          *
        </span>
      </label>
      <div
        class="w-full flex justify-between self-stretch"
        :class="{ 'text-[var(--p-form-field-disabled-color)]': disabled }"
      >
        <slot />
      </div>
    </div>
    <InputHint
      v-if="!noHint"
      :hint="error ? errorMessage : hint"
      class="mt-1 text-xs"
      :class="[error ? errorClass : hintClass]"
    />
  </div>
</template>
